import { render, staticRenderFns } from "./vehicle-driver-infos.vue?vue&type=template&id=752391ec&scoped=true"
import script from "./vehicle-driver-infos.vue?vue&type=script&lang=js"
export * from "./vehicle-driver-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752391ec",
  null
  
)

export default component.exports